<template>
  <div
    :class="{'border-bottom': borderBottom, 'border-top': borderTop, 'border-left': borderLeft, 'border-right': borderRight}"
    class="row choice-radio"
    @click="click">
    <div class="col-10 text-left font-weight-bold column">
      <span class="name"><slot/></span>
    </div>
    <div class="col-2 column column justify-content-end">
      <RadioInput
        ref="radioInput"
        :value="value"
        :checked="checked"
        @input="input"/>
    </div>
  </div>
</template>

<script>
import RadioInput from '@/components/Forms/RadioInput';

export default {
  name: 'ChoiceRadio',
  components: {
    RadioInput,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    checked: {
      type: Boolean,
      default: false,
    },
    borderBottom: {
      type: Boolean,
      default: false,
    },
    borderTop: {
      type: Boolean,
      default: false,
    },
    borderLeft: {
      type: Boolean,
      default: false,
    },
    borderRight: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    input(val) {
      this.$emit('input', val);
    },
    click() {
      this.$refs.radioInput.$el.click();
    },
  },
};
</script>

<style scoped lang="scss">
div {
  &.choice-radio {
    padding: 10px 0;
    background-color: $base;
    color: $primary;
    cursor: pointer;
  }
  &.column {
    display: flex;
    align-items: center;
  }
}

span {
  &.name {
    cursor: pointer;
  }
}
</style>
